import SendRequest from "../services/sendRequest.service";

export const getCookieValue = (name) =>
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';

export const postToNativeApp = async(data)=>{
  window.postMessage(
    JSON.stringify(data),
    '*'
  );
}



/**
 * Function to receive data from Native App as a callback.
 * @param {Callback} callback 
 */
export const getFromNativeApp = async(callback)=>{
  window.onmessage=callback;
}